import de from './locales/de.json'
import fr from './locales/fr.json'

export default defineI18nConfig(() => ({
  legacy: false,
  locale: 'de',
  fallbackLocale: 'de',
  messages: {
    de,
    fr,
  },
}))
